import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<labs-app-layout-main-content>` renders the main content within the `<labs-app-layout>` component
 */
@Component({
  selector: 'labs-app-layout-main-content',
  template: '<ng-content></ng-content>',
  styleUrls: ['./app-layout-main-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppLayoutMainContentComponent {}
